import React, { useState } from 'react';
import { motion, AnimatePresence, useReducedMotion } from 'framer-motion';
import { Star, Check, ShieldCheck, Sparkles, SparklesIcon } from 'lucide-react';
const PORTAL_IMAGE = 'https://cdn.magicpatterns.com/uploads/uhLrwtrZAkjAonsADz8Jfe/ChatGPT_Image_27_may_2026,_15_23_37.png';
const COMPLETE_EXPERIENCE_IMAGE = 'https://cdn.magicpatterns.com/uploads/5yrQLTQ4vG3TPBLs1DkjKn/Kit_Terapeutico_y_Tarot_Completo.webp';
export function UpsellPurchase() {
  const [selectedTier, setSelectedTier] = useState(1);
  const [selectedExtraKit, setSelectedExtraKit] = useState('radiestesia');
  const [includesInterpretation, setIncludesInterpretation] = useState(false);
  const prefersReducedMotion = useReducedMotion();
  const tiers = [{
    id: 1,
    title: 'Solo Constelación Familiar Terapéutica',
    price: '19.990',
    oldPrice: '59.900',
    description: 'Guía Constelación Familiar Terapéutica PDF + 5 Bonos',
    badge: null
  }, {
    id: 2,
    title: 'Guía Constelación Familiar + 1 Kit Opcional',
    price: '29.990',
    oldPrice: '79.900',
    description: 'Elegí un kit adicional para complementar tu formación',
    badge: 'MÁS ELEGIDO'
  }, {
    id: 3,
    title: 'PORTAL TERAPÉUTICO COMPLETO ✨',
    price: '39.990',
    oldPrice: '79.960',
    description: 'Acceso total: Constelaciones + Radiestesia + Reiki + Tarot + Todos sus bonos',
    badge: 'MEJOR VALOR 🔥'
  }];
  const extraKits = [{
    id: 'radiestesia',
    name: 'Kit Radiestesia Profesional',
    icon: '⚡'
  }, {
    id: 'constelaciones',
    name: 'Kit Reiki Profesional',
    icon: '🌸'
  }, {
    id: 'tarot',
    name: 'Kit Tarot Terapéutico',
    icon: '🔮'
  }];
  const selectedTierData = tiers.find(tier => tier.id === selectedTier) ?? tiers[0];
  const isPortalSelected = selectedTier === 3;
  const hasPremiumExperience = isPortalSelected && includesInterpretation;
  const formatPrice = (price: number) => price.toLocaleString('es-AR');
  const baseFinalPrice = Number(selectedTierData.price.replace('.', ''));
  const baseRegularPrice = Number(selectedTierData.oldPrice.replace('.', ''));
  const finalPrice = hasPremiumExperience ? 49980 : baseFinalPrice;
  const regularPrice = hasPremiumExperience ? 99990 : baseRegularPrice;
  const savings = regularPrice - finalPrice;
  const discountPercentage = Math.round((1 - finalPrice / regularPrice) * 100);
  const getTierImage = () => {
    switch (selectedTier) {
      case 1:
        return 'https://cdn.magicpatterns.com/uploads/tLMwVRmFZMdaPSk4RHPedW/Kit_terapeutico_Constelacion_Familiar.webp';
      case 2:
        if (selectedExtraKit === 'constelaciones') {
          return 'https://cdn.magicpatterns.com/uploads/9QYyXAwynRUHkQM3Qc8pQ1/ChatGPT_Image_27_may_2026,_15_37_22.webp';
        }
        if (selectedExtraKit === 'radiestesia') {
          return 'https://cdn.magicpatterns.com/uploads/v6kRZf3jNj4e4TB6hjAK9D/05393dcc-e8a9-4158-8638-bcd33da82c23.webp';
        }
        if (selectedExtraKit === 'tarot') {
          return 'https://cdn.magicpatterns.com/uploads/o2XCPLtjmFwNJTm4HqkEvR/6e7f317b-cb85-4de6-a3fe-bd663b8856bd.webp';
        }
        return 'https://cdn.magicpatterns.com/uploads/8RK1DxmEDW9bikSa4Hmuhy/3fb58353-4ad6-48eb-9650-c6e23b130f14.webp';
      case 3:
        return hasPremiumExperience ? COMPLETE_EXPERIENCE_IMAGE : PORTAL_IMAGE;
      default:
        return 'https://cdn.magicpatterns.com/uploads/5VCzCikRCrmivshx868yTg/3fb58353-4ad6-48eb-9650-c6e23b130f14.webp';
    }
  };
  const handleCheckout = () => {
    let checkoutUrl = '';
    if (selectedTier === 1) {
      checkoutUrl = 'https://codex-labs.shop/cart/43433734733883:1';
    }
    if (selectedTier === 3) {
      checkoutUrl = includesInterpretation ? 'https://www.codex-labs.shop/cart/44528114892859:1' : 'https://codex-labs.shop/cart/43552261701691:1';
    }
    if (selectedTier === 2 && selectedExtraKit === 'radiestesia') {
      checkoutUrl = 'https://codex-labs.shop/cart/43553639530555:1';
    }
    if (selectedTier === 2 && selectedExtraKit === 'constelaciones') {
      checkoutUrl = 'https://codex-labs.shop/cart/43552280313915:1';
    }
    if (selectedTier === 2 && selectedExtraKit === 'tarot') {
      checkoutUrl = 'https://codex-labs.shop/cart/43553649524795:1';
    }
    if (checkoutUrl) {
      window.location.href = checkoutUrl;
    }
  };
  return <section id="purchase" className="py-20 px-4 bg-[#fdfbf7] pt-[15px] pb-[15px]" data-id="element-325" data-mp="1i51z92o1fxd8">
      <div className="max-w-[440px] mx-auto bg-white rounded-[3rem] shadow-[0_20px_50px_rgba(124,58,237,0.1)] border border-[#f3e8ff] overflow-hidden" data-id="element-326" data-mp="1d7il02rcbkla">
        <div className="p-8 text-center pt-[15px] pb-[15px] pl-[10px] pr-[10px]" data-id="element-327" data-mp="14eyhanw6yptl">
          {/* Social Proof Header */}
          <div className="mb-[10px]" data-id="element-328" data-mp="20x4lctjg85uv">
            <p className="text-[#a78bfa] font-black text-sm tracking-widest uppercase mb-2" data-id="element-329" data-mp="20y5x708agwdn">
              +3.269 TERAPÉUTAS DENTRO
            </p>
            <div className="flex justify-center gap-1 text-yellow-400 mb-1" data-id="element-330" data-mp="3eteaitqfx0pg">
              {[...Array(5)].map((_, i) => <Star key={i} size={20} fill="currentColor" data-id="element-331" data-mp="3jrz9kptyhecb" data-mpi={i} />)}
            </div>
            <p className="text-[#a78bfa] text-sm font-bold" data-id="element-332" data-mp="3nrhkqtvz6b1y">(1.728 reseñas)</p>
          </div>

          <div className="inline-block bg-[#fffbeb] text-[#92400e] px-6 py-1.5 rounded-full text-[10px] font-black uppercase tracking-widest mb-8 border border-[#fef3c7]" data-id="element-333" data-mp="3ssx8wutg8xok">
            ECOSISTEMA TERAPÉUTICO PROFESIONAL
          </div>

          <div className="mb-[10px]" data-id="element-334" data-mp="6ikvgk1y1awl">
            <h2 className="text-[#1e1b4b] font-['Playfair_Display',_serif] text-[28px] md:text-[32px] font-bold leading-tight mb-1" data-id="element-335" data-mp="bbdzf5pl8f7m">
              Elegí el camino terapéutico
            </h2>
            <span className="text-[#d97706] font-['Dancing_Script',_cursive] block text-[36px] md:text-[42px] leading-none" data-id="element-336" data-mp="kcu6p4l3w17m">
              que mejor conecte con vos
            </span>
            <div className="flex justify-center mt-4" data-id="element-337" data-mp="2lea9ize5t01z">
              <Sparkles className="text-[#fbbf24] w-8 h-8 opacity-60" data-id="element-338" data-mp="2letgjl29u418" />
            </div>
          </div>

          <p className="text-[#a78bfa] font-medium mb-10 px-8 text-[14px]" data-id="element-339" data-mp="2gha2om9hjt9t">
            Accedé de forma inmediata a nuestros programas terapéuticos
            profesionales con acceso de por vida, material 100% digital en
            formato PDF descargable y futuras actualizaciones incluidas.
          </p>

          <div className="flex items-center justify-center gap-4 mb-8" data-id="element-340" data-mp="3474c0tulizpb">
            <span className="font-black text-[#a78bfa] uppercase tracking-[0.2em] flex gap-2 items-center justify-start text-[11px]" data-id="element-341" data-mp="302wmwvk87hqk">
              ↓ SELECCIONÁ EL PACK QUE PREFIERAS: ↓
            </span>
          </div>

          {/* Tiers List */}
          <div className="space-y-4 mb-8" data-id="element-342" data-mp="1joy3zrdfbe33">
            {tiers.map(tier => <div key={tier.id} className="relative" data-id="element-343" data-mp="1jr13d20gujkh">
                {tier.badge && <div className={`absolute -top-3 right-4 z-10 rounded-full px-3 py-1 text-[9px] font-black uppercase tracking-widest text-white shadow-lg ${tier.id === 2 ? 'bg-[#61940f] shadow-[0_8px_18px_-8px_rgba(97,148,15,0.85)]' : 'bg-[#b78b31] shadow-[0_8px_18px_-8px_rgba(183,139,49,0.85)]'}`} data-id="element-344" data-mp="1es7s7g8nj4nh">
                    ✦ {tier.badge}
                  </div>}
                <button onClick={() => {
              setSelectedTier(tier.id);
              if (tier.id !== 3) setIncludesInterpretation(false);
            }} className={`relative w-full overflow-hidden rounded-2xl border-2 p-5 text-left transition-[border-color,background-color,box-shadow] duration-300 ease-out ${tier.id === 3 ? selectedTier === 3 ? 'border-[#d7ae4d] bg-[#2e1065] shadow-[0_18px_34px_-22px_rgba(46,16,101,0.9)]' : 'border-[#ddd0b0] bg-[#fffdf8]' : tier.id === 2 ? selectedTier === 2 ? 'border-[#84cc16] bg-[#f8fff1] shadow-[0_14px_28px_-24px_rgba(132,204,22,0.85)]' : 'border-[#dcedcb] bg-white' : selectedTier === 1 ? 'border-[#7c3aed] bg-[#f5f3ff] shadow-[0_14px_28px_-24px_rgba(124,58,237,0.6)]' : 'border-[#f3e8ff] bg-white'}`} data-id="element-345" data-mp="37mywf6x6r7os">
                  <div className="flex items-start gap-4" data-id="element-346" data-mp="2x37lcrr2tidz">
                    <motion.div animate={prefersReducedMotion || selectedTier !== tier.id ? undefined : {
                  scale: [1, 1.08, 1]
                }} transition={{
                  duration: 0.45,
                  ease: [0.23, 1, 0.32, 1]
                }} className={`mt-1 flex h-6 w-6 shrink-0 items-center justify-center rounded-full border-2 ${selectedTier === tier.id ? tier.id === 3 ? 'border-[#e2bd65] bg-[#b78b31] text-white shadow-[0_0_16px_rgba(226,189,101,0.7)]' : tier.id === 2 ? 'border-[#84cc16] bg-[#61940f] text-white shadow-[0_0_14px_rgba(132,204,22,0.55)]' : 'border-[#7c3aed] bg-[#7c3aed] text-white' : 'border-[#ddd6fe]'}`} data-id="element-347" data-mp="2x1o3wxtop1am">
                      {selectedTier === tier.id && <Check size={14} strokeWidth={4} data-id="element-348" data-mp="ez95se94la0r" />}
                    </motion.div>
                    <div className="flex-1" data-id="element-349" data-mp="juy8gqgfz71a">
                      <div className="flex justify-between items-start mb-1" data-id="element-350" data-mp="ovvooxhw5r05">
                        <h3 className={`font-black text-sm uppercase tracking-tight ${selectedTier === tier.id ? tier.id === 3 ? 'text-white' : tier.id === 2 ? 'text-[#507b0d]' : 'text-[#7c3aed]' : 'text-blue-950'}`} data-id="element-351" data-mp="1vbep2n3qftpq">
                          {tier.title}
                        </h3>
                        <div className="text-right" data-id="element-352" data-mp="2ar8fkehts102">
                          <p className={`text-[10px] font-bold leading-none line-through ${selectedTier === tier.id && tier.id === 3 ? 'text-[#d9cba8]' : 'text-[#a78bfa]'}`} data-id="element-353" data-mp="1e06hafg39635">
                            ${tier.oldPrice}
                          </p>
                          <p className={`mt-1 text-lg font-black leading-none ${selectedTier === tier.id ? tier.id === 3 ? 'text-[#e2bd65]' : tier.id === 2 ? 'text-[#61940f]' : 'text-[#7c3aed]' : 'text-[#319E0D]'}`} data-id="element-354" data-mp="1n25wr3bgg23z">
                            ${tier.price}
                          </p>
                        </div>
                      </div>
                      <p className={`text-[11px] font-medium leading-tight ${selectedTier === tier.id && tier.id === 3 ? 'text-[#e7ddf0]' : 'text-blue-950/40'}`} data-id="element-355" data-mp="d1aadnrep7dj">
                        {tier.description}
                      </p>
                    </div>
                  </div>
                </button>

                {/* Extra Kit Selector for Tier 2 */}
                <AnimatePresence data-id="element-356" data-mp="3q8v7plf3da7j">
                  {selectedTier === 2 && tier.id === 2 && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} className="overflow-hidden" data-id="element-357" data-mp="1tglaypoehono">
                      <div className="mt-4 p-4 bg-[#f5f3ff]/50 rounded-2xl border-2 border-[#ddd6fe] space-y-2" data-id="element-358" data-mp="3dxufk3to8a2w">
                        <p className="text-[10px] font-black text-[#7c3aed] uppercase tracking-widest mb-3" data-id="element-359" data-mp="5i10ltezn6ny">
                          SELECCIONÁ TU KIT ADICIONAL:
                        </p>
                        {extraKits.map(kit => <button key={kit.id} onClick={() => setSelectedExtraKit(kit.id)} className={`flex w-full items-center justify-between rounded-xl border p-3 transition-[background-color,border-color,box-shadow,color] duration-200 ease-out ${selectedExtraKit === kit.id ? 'bg-white border-[#7c3aed] shadow-sm text-[#7c3aed]' : 'bg-white/50 border-[#f3e8ff] text-[#a78bfa]'}`} data-id="element-360" data-mp="3smqpk6fafx65">
                            <div className="flex items-center gap-2 text-xs font-bold" data-id="element-361" data-mp="28qkx9s1q0awn">
                              <span data-id="element-362" data-mp="2nnleh1macngv">{kit.icon}</span>
                              {kit.name}
                            </div>
                            <div className={`w-4 h-4 rounded-full border flex items-center justify-center ${selectedExtraKit === kit.id ? 'border-[#7c3aed] bg-[#7c3aed] text-white' : 'border-[#ddd6fe]'}`} data-id="element-363" data-mp="2in62addqpm0h">
                              {selectedExtraKit === kit.id && <Check size={10} strokeWidth={4} data-id="element-364" data-mp="1zxzdq9q9m06r" />}
                            </div>
                          </button>)}
                      </div>
                    </motion.div>}
                </AnimatePresence>
              </div>)}
          </div>

          <AnimatePresence data-id="element-365" data-mp="akb7dvlbmury">
            {isPortalSelected && <motion.label initial={prefersReducedMotion ? undefined : {
            opacity: 0,
            y: 10
          }} animate={prefersReducedMotion ? undefined : {
            opacity: 1,
            y: 0
          }} exit={prefersReducedMotion ? undefined : {
            opacity: 0,
            y: -8
          }} transition={{
            duration: 0.3,
            ease: [0.23, 1, 0.32, 1]
          }} className={`mb-6 flex cursor-pointer items-start gap-3 rounded-2xl border p-4 text-left transition-[background-color,border-color] duration-300 ease-out ${hasPremiumExperience ? 'border-[#d7ae4d] bg-[#2e1065] text-white' : 'border-[#e8decf] bg-[#fffdf8] text-[#2e1065]'}`} data-id="element-366" data-mp="el3h0py3v1or">
                <input type="checkbox" checked={includesInterpretation} onChange={event => setIncludesInterpretation(event.target.checked)} className="mt-0.5 h-5 w-5 shrink-0 accent-[#b78b31]" data-id="element-367" data-mp="342u4mewrpw2q" />
                <span data-id="element-368" data-mp="2wp32ae2nf9mg">
                  <span className="block text-[12px] font-black uppercase leading-snug tracking-[0.05em]" data-id="element-369" data-mp="2wnrxqc1dpxua">
                    Sí, quiero agregar el Pack Interpretación Completa por solo $9.990
                  </span>
                  <span className={`mt-1 block text-[12px] leading-relaxed ${hasPremiumExperience ? 'text-[#e7ddf0]' : 'text-[#665873]'}`} data-id="element-370" data-mp="3kffew28u9ujd">
                    Incluye El Lenguaje del Tarot, Diccionario de Combinaciones y sus bonos.
                  </span>
                </span>
              </motion.label>}
          </AnimatePresence>

          {/* Mockup Visual */}
          <div className="mb-6 overflow-hidden rounded-2xl border border-[#f3e8ff] shadow-xl" data-id="element-371" data-mp="36hquevioopeu">
            <AnimatePresence mode="wait" data-id="element-372" data-mp="1yzzw95vagagw">
              <motion.img key={`${selectedTier}-${hasPremiumExperience}`} initial={prefersReducedMotion ? undefined : {
              opacity: 0,
              scale: 0.97
            }} animate={prefersReducedMotion ? undefined : {
              opacity: 1,
              scale: 1
            }} exit={prefersReducedMotion ? undefined : {
              opacity: 0,
              scale: 1.02
            }} transition={{
              duration: prefersReducedMotion ? 0 : 0.35,
              ease: [0.23, 1, 0.32, 1]
            }} src={getTierImage()} alt={hasPremiumExperience ? 'Combo Portal Terapéutico con Pack Interpretación Completa' : 'Pack Portal Terapéutico Completo'} className="h-auto w-full object-contain" data-id="element-373" data-mp="1uzzjrqrr29ch" />
            </AnimatePresence>
          </div>

          {/* Pricing Final */}
          <motion.div layout transition={{
          duration: prefersReducedMotion ? 0 : 0.35,
          ease: [0.23, 1, 0.32, 1]
        }} className={`relative mb-5 overflow-hidden rounded-2xl border px-5 py-5 text-center transition-[background-color,border-color,box-shadow] duration-500 ease-out ${hasPremiumExperience ? 'border-[#e2bd65] bg-[#241047] shadow-[0_20px_44px_-20px_rgba(46,16,101,0.95)]' : isPortalSelected ? 'border-[#d7ae4d] bg-[#fdf9f0] shadow-[0_16px_34px_-24px_rgba(46,16,101,0.75)]' : selectedTier === 2 ? 'border-[#b8dc7d] bg-[#fbfff6]' : 'border-[#f3e8ff] bg-[#faf8ff]'}`} data-id="element-374" data-mp="18s3mv8jgqcl4">
            {hasPremiumExperience && <>
                <span className="inline-flex items-center gap-1 rounded-full bg-[#e2bd65] px-3 py-1 text-[10px] font-black uppercase tracking-[0.1em] text-[#2e1065]" data-id="element-375" data-mp="u5wskstupnys">
                  <SparklesIcon size={12} aria-hidden="true" data-id="element-376" data-mp="17ymdetxn8mub" /> Experiencia más completa
                </span>
                <p className="mt-3 text-sm font-bold text-white" data-id="element-377" data-mp="1huz91xcr1arp">
                  ¡Desbloqueaste el pack más completo!
                </p>
              </>}
            <p className={`mt-3 text-[12px] font-black uppercase tracking-[0.16em] ${hasPremiumExperience ? 'text-[#e7ddf0]' : 'text-[#776a7f]'}`} data-id="element-378" data-mp="1cxpk0it9v14e">
              Precio regular
            </p>
            <p className={`mt-1 text-[16px] font-bold line-through ${hasPremiumExperience ? 'text-[#d9cba8]' : 'text-[#9d8ea4]'}`} data-id="element-379" data-mp="2o840918h5mbn">
              ${formatPrice(regularPrice)}
            </p>
            {discountPercentage > 0 && <span className={`mt-3 inline-flex rounded-full px-3 py-1 text-[12px] font-black uppercase tracking-[0.08em] ${hasPremiumExperience ? 'bg-[#e2bd65] text-[#2e1065]' : 'bg-[#84cc16] text-white'}`} data-id="element-380" data-mp="20kcqo5ebjne2">
                {discountPercentage}% OFF
              </span>}
            <p className={`mt-3 text-[12px] font-black uppercase tracking-[0.16em] ${hasPremiumExperience ? 'text-[#e7ddf0]' : 'text-[#776a7f]'}`} data-id="element-381" data-mp="2agpgutannj42">
              Precio final
            </p>
            <div className={`relative mt-1 inline-block overflow-hidden ${hasPremiumExperience ? 'price-metallic-glow' : ''}`} data-id="element-382" data-mp="1hrqvlnb8k0uj">
              <p className={`whitespace-nowrap text-[44px] font-black leading-none tracking-tight md:text-5xl ${hasPremiumExperience ? 'bg-[linear-gradient(105deg,#b8872f,#fff0b2,#c99b3e)] bg-clip-text text-transparent' : isPortalSelected ? 'text-[#b78b31]' : selectedTier === 2 ? 'text-[#61940f]' : 'text-[#319E0D]'}`} data-id="element-383" data-mp="1f95aw93hk6wj">
                ${formatPrice(finalPrice)}
              </p>
              {!prefersReducedMotion && hasPremiumExperience && <span aria-hidden="true" className="purchase-shine-premium" data-id="element-384" data-mp="mkrcvtcedakz" />}
              {!prefersReducedMotion && !hasPremiumExperience && isPortalSelected && <span aria-hidden="true" className="purchase-shine-gold" data-id="element-385" data-mp="hmpy3km07xfb" />}
              {!prefersReducedMotion && selectedTier === 2 && <span aria-hidden="true" className="purchase-shine-green" data-id="element-386" data-mp="clsd709m0pa4" />}
            </div>
            <p className={`mt-3 text-xs font-bold ${hasPremiumExperience ? 'text-[#e7ddf0]' : 'text-[#665873]'}`} data-id="element-387" data-mp="8li7zptn62wb">
              Ahorrás ${formatPrice(savings)}
            </p>
          </motion.div>

          {/* CTA Button */}
          <motion.button onClick={handleCheckout} whileHover={{
          scale: 1.02
        }} whileTap={{
          scale: 0.98
        }} className={`group relative mb-6 w-full overflow-hidden rounded-3xl py-6 shadow-[0_15px_30px_rgba(132,204,22,0.4)] transition-[background-color,box-shadow,transform] duration-300 ease-out ${hasPremiumExperience ? 'bg-[linear-gradient(105deg,#b8872f,#f4d98f,#c99b3e)] text-[#2e1065] shadow-[0_18px_34px_rgba(226,189,101,0.38)] hover:shadow-[0_20px_38px_rgba(226,189,101,0.52)]' : isPortalSelected ? 'bg-[#2e1065] text-white shadow-[0_18px_34px_rgba(46,16,101,0.34)] hover:bg-[#3d187f]' : 'bg-[#84cc16] text-white hover:bg-[#74c445]'}`} data-id="element-388" data-mp="2om0h82y8o45g">
            <span className="relative z-10 text-3xl font-black uppercase italic tracking-tighter" data-id="element-389" data-mp="2fdsthrkqov9">
              ACCEDER AHORA
            </span>
            {!prefersReducedMotion && hasPremiumExperience && <span aria-hidden="true" className="purchase-shine-premium" data-id="element-390" data-mp="cfo6f3hityay" />}
            {!prefersReducedMotion && !hasPremiumExperience && isPortalSelected && <span aria-hidden="true" className="purchase-shine-gold" data-id="element-391" data-mp="gdvmdw45uvl3" />}
            {!prefersReducedMotion && selectedTier === 2 && <span aria-hidden="true" className="purchase-shine-green" data-id="element-392" data-mp="3ku6hle2rdtys" />}
          </motion.button>

          <div className="flex items-center justify-center gap-2 pt-2 text-[10px] font-bold uppercase tracking-widest text-[#a78bfa]" data-id="element-393" data-mp="3ow9wkcomzgot">
            <ShieldCheck size={14} data-id="element-394" data-mp="3tnrtmpnjgx4i" />
            Pago 100% seguro y protegido
          </div>

          {/* Trust Section */}
          <div className="border-t-2 border-dashed border-blue-50 pt-[0px] mt-[0px] space-y-[5px]" data-id="element-395" data-mp="2x4lo418zbeb9">
            <img src="https://cdn.magicpatterns.com/uploads/eU118ieSDgWuz64T6oQtAx/capture_260410_163646.png" alt="Pago Seguro Garantizado" className="w-full h-auto object-contain" data-id="element-396" data-mp="314m8e2irejq8" />

            <div className="text-center" data-id="element-397" data-mp="i1ies3b9th5d">
              <img src="https://cdn.magicpatterns.com/uploads/skccFFLzCHBogMzzjkfEmF/7ef4071d-c511-4325-9d9d-f2158f7b8632.jpg" alt="MercadoLíder Platinum" className="w-full h-auto object-contain shadow-sm rounded-xl" data-id="element-398" data-mp="i18n8bakv1xk" />
            </div>

            <div className="bg-blue-50/50 p-4 rounded-2xl border border-blue-100" data-id="element-399" data-mp="3gkyrusk990eh">
              <p className="text-blue-950 font-black text-[10px] uppercase tracking-widest mb-3" data-id="element-400" data-mp="3uk85bkh2tger">
                Tu Compra está Protegida
              </p>
              <div className="flex items-center justify-center gap-4" data-id="element-401" data-mp="19sxxhm9pijqb">
                <img src="https://cdn.magicpatterns.com/uploads/7eCtKk7WA3cLyGaeie1cdM/png-clipart-safe-purchase-payment-security-shop-shopping-online-store-e-commerce-sign-green-texta.png" alt="Compra Segura" className="h-10 object-contain" data-id="element-402" data-mp="19r4t6dmkgblh" />
                <img src="https://cdn.magicpatterns.com/uploads/fpbSfdYZaTGuGJTHBKUizP/Selo_de_Garantia_de_7_Dias_PNG_Transparente_Sem_Fundo.png" alt="Garantía de 7 Días" className="h-14 object-contain" data-id="element-403" data-mp="1i7lvdrrl2ipy" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}